import request from "./request";
/**
 * 注册
 * @param userName 账号
 * @param passWord 密码
 */
export default async function register(data) {
  return await request.post("/spin/sysUser/register", data);
}
